import { render, staticRenderFns } from "./UserDeck.vue?vue&type=template&id=37aa74fc&"
import script from "./UserDeck.vue?vue&type=script&lang=js&"
export * from "./UserDeck.vue?vue&type=script&lang=js&"
import style0 from "./UserDeck.vue?vue&type=style&index=0&id=37aa74fc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports